export default __webpack_public_path__ + "static/media/choose-instagram-en.c59bd402.png";